import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=685991de&lang=pug&"
import script from "./tab.vue?vue&type=script&lang=js&"
export * from "./tab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/serg/my/projects/pub.settv.ru/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('685991de')) {
      api.createRecord('685991de', component.options)
    } else {
      api.reload('685991de', component.options)
    }
    module.hot.accept("./tab.vue?vue&type=template&id=685991de&lang=pug&", function () {
      api.rerender('685991de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/components/tab.vue"
export default component.exports